import { useEffect, useState } from 'react'
import { faClose, faPlay } from '@fortawesome/free-solid-svg-icons'
import Image from 'next/image'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import Icon from '../Icon'
import theme from '../../theme/cheddar'
import style from '../../styles/components/story/related'

const UpNextStory = ({ story, pageScrolled, showUpnext }) => {
  const [visible, setVisible] = useState(true)
  const { isMobile } = useMediaQuery()

  useEffect(() => {
    showUpnext()
  }, [showUpnext])

  return (
    <>
      <div className={`upnext-container ${visible && pageScrolled ? 'show' : ''}`}>
        <div className='close-button' title='Close' onClick={() => setVisible(false)}>
          <Icon icon={faClose} size={isMobile ? 'lg' : 'xl'} color={theme.colors.nero} />
        </div>
        <a href={`/media/${story?.slug}`} className='story-info' title='Watch Next'>
          <div className='thumbnail'>
            <Image src={story?.thumbnail?.url} width={story?.thumbnail?.width} height={story?.thumbnail?.height} alt={story?.title} />
          </div>
          <div className='content'>
            <div className='cta'>WATCH NEXT</div>
            <div className='title'>{story?.title}</div>
          </div>
          <div className='play-button'>
            <Icon icon={faPlay} size={isMobile ? '1x' : '2x'} color={theme.colors.white} />
          </div>
        </a>
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default UpNextStory
